export default {
    meta: {
        title: '拓店宝-店铺定位'
    }
};
